import { render, staticRenderFns } from "./PedidosNavigation.vue?vue&type=template&id=3932d4b9&scoped=true&"
import script from "./PedidosNavigation.vue?vue&type=script&lang=ts&"
export * from "./PedidosNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./PedidosNavigation.vue?vue&type=style&index=0&id=3932d4b9&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3932d4b9",
  null
  
)

export default component.exports